// VIP Contact Form
// Replaces the Tally embed with a native form posting directly to the
// same Apps Script endpoint the evaluator gate already captures to
// (see vip-gate.js's vipCaptureCommit). Unlike the gate's fire-and-forget
// capture, this DOES await the response and shows the reader a real
// sent/error state - a contact submission needs confirmation, the gate
// capture does not.
//
// AUTHORING CONTRACT (the HTML pasted into the Ghost Contact page as an
// HTML card, replacing the Tally iframe + its <script>):
//
//   <div class="vip-contact">
//     <form class="vip-contact-form" novalidate>
//       <div class="vip-contact-field">
//         <label for="vip-contact-name">Name</label>
//         <input type="text" id="vip-contact-name" name="name" autocomplete="name" required>
//       </div>
//       <div class="vip-contact-field">
//         <label for="vip-contact-email">Email</label>
//         <input type="email" id="vip-contact-email" name="email" autocomplete="email" required>
//       </div>
//       <div class="vip-contact-field">
//         <label for="vip-contact-message">Message</label>
//         <textarea id="vip-contact-message" name="message" rows="5" required></textarea>
//       </div>
//       <div class="vip-contact-honeypot">
//         <label for="vip-contact-website">Website</label>
//         <input type="text" id="vip-contact-website" name="website" tabindex="-1" autocomplete="off">
//       </div>
//       <button class="vip-contact-submit" type="submit">Send message</button>
//       <div class="vip-contact-status" role="status" aria-live="polite"></div>
//     </form>
//   </div>
//
// The honeypot field must stay in normal flow (moved off-screen via CSS,
// not display:none/visibility:hidden) so bots that only skip hidden
// fields still fill it in - see .vip-contact-honeypot in vip.css.
//
// Rules the markup must follow (a malformed form is left exactly as
// authored - native HTML validation and a plain POST still work with no
// JS, since this is a real <form>, not a fail-open no-op like the gate):
//   - Fields must be named name / email / message / website.
//   - Exactly one .vip-contact-status live region per form.

(function() {
    'use strict';

    var ENDPOINT = 'https://script.google.com/macros/s/AKfycbxfIJoTyVhaa1_rS4yLIuAH-p7mMhWyobj6VT5PAHY3k8UhPNTxp19oYh3QTM8kkGYy/exec';
    var TOKEN = 'VIPCommits20261234321';
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function showStatus(statusEl, kind, message) {
        statusEl.textContent = message;
        statusEl.classList.remove('is-success', 'is-error');
        statusEl.classList.add(kind === 'success' ? 'is-success' : 'is-error');
    }

    function setSubmitting(form, submitBtn, submitting) {
        submitBtn.disabled = submitting;
        form.classList.toggle('is-submitting', submitting);
    }

    function vipSubmitContact(form, submitBtn, statusEl) {
        var name = form.name.value.trim();
        var email = form.email.value.trim();
        var message = form.message.value.trim();

        if (!name || !email || !message) {
            showStatus(statusEl, 'error', 'Please fill in all fields.');
            return;
        }
        if (!EMAIL_RE.test(email)) {
            showStatus(statusEl, 'error', 'Please enter a valid email address.');
            return;
        }

        setSubmitting(form, submitBtn, true);

        fetch(ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify({
                type: 'contact',
                token: TOKEN,
                name: name,
                email: email,
                message: message,
                website: form.website.value
            })
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            if (data.ok) {
                showStatus(statusEl, 'success', 'Thanks — your message has been sent.');
                form.reset();
            } else {
                showStatus(statusEl, 'error', data.error || 'Something went wrong. Please try again.');
            }
        }).catch(function() {
            showStatus(statusEl, 'error', "We couldn't confirm your message was sent. Please try again, or email us directly.");
        }).finally(function() {
            setSubmitting(form, submitBtn, false);
        });
    }

    function initContactForm(form) {
        var statusEl = form.querySelector('.vip-contact-status');
        var submitBtn = form.querySelector('.vip-contact-submit');
        if (!statusEl || !submitBtn || !form.name || !form.email || !form.message || !form.website) {
            console.warn('[vip-contact] malformed form, leaving native submit behavior:', form);
            return;
        }

        form.addEventListener('submit', function(e) {
            e.preventDefault();
            vipSubmitContact(form, submitBtn, statusEl);
        });
    }

    function init() {
        try {
            var forms = document.querySelectorAll('.vip-contact-form');
            Array.prototype.forEach.call(forms, function(form) {
                try {
                    initContactForm(form);
                } catch (e) {
                    console.warn('[vip-contact] failed to initialize, leaving as authored:', e, form);
                }
            });
        } catch (e) {
            console.warn('[vip-contact] top-level init failed:', e);
        }
    }

    // Bootstrapping wrapped per CLAUDE.md §7: all theme JS concatenates
    // into one casper.js, so this guards against this component's own
    // setup throwing and taking down anything concatenated after it.
    try {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
    } catch (e) {
        console.warn('[vip-contact] failed to bootstrap:', e);
    }
})();
